import ApexLogo from './apex-logo.png';
import React, { Component } from "react";
import axios from "axios";
import { Navigate } from 'react-router-dom';

export class ForgotPassword extends Component {
    constructor(props) {
        super(props);
    }

    state = {
        username: '',
        code: '',
        newPassword: '',
        reTypePassword: '',
        loginStatus: 0,
        redirect: false,
        page: 0,
        isLoading: false
    }

    handleUsernameInput = event => {
        this.setState({ username: event.target.value });
    };

    handleCodeInput = event => {
        this.setState({ code: event.target.value });
    };

    handleNewPasswordInput = event => {
        this.setState({ newPassword: event.target.value });
    };

    handleReTypePassword = event => {
        this.setState({ reTypePassword: event.target.value });
    };

    onKeyUp = event => {
        if (event.charCode === 13) {
            this.resetPassword(event);
        }
    };

    onKeyUpCode = event => {
        if (event.charCode === 13) {
            this.verifyCode(event);
        }
    };

    onKeyUpPassword = event => {
        if (event.charCode === 13) {
            this.newPassword(event);
        }
    };

    onKeyUpReTypePassword = event => {
        if (event.charCode === 13) {
            this.newPassword(event);
        }
    };

    resetPassword = event => {
        event.preventDefault();
        this.setState({ loginStatus: 0, isLoading: true });
        let userObj = {
            username: this.state.username
        }
        if (this.state.username !== "") {
            axios.post(`auth/forgot-password`, userObj)
                .then(response => {
                    if (response.data.otpSent === 200) {
                        this.setState({ page: 1, username: response.data.email, isLoading: false });
                    } else {
                        this.setState({ loginStatus: 4, isLoading: false });
                    }
                }).catch(error => {
                    console.error('There was an error!', error);
                    this.setState({ loginStatus: 2, isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
        }
    };

    verifyCode = event => {
        event.preventDefault();
        this.setState({ loginStatus: 0, isLoading: true });
        let verifyObj = {
            code: this.state.code,
            username: this.state.username
        }
        if (this.state.code !== "") {
            axios.post(`auth/verify-code`, verifyObj)
                .then(response => {
                    if (response.data.codeVerified === 200) {
                        this.setState({ page: 2, username: response.data.email, isLoading: false });
                    } else {
                        this.setState({ loginStatus: 3, isLoading: false });
                    }
                }).catch(error => {
                    console.error('There was an error!', error);
                    this.setState({ loginStatus: 2, isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
        }
    };

    newPassword = event => {
        event.preventDefault();
        this.setState({ loginStatus: 0, isLoading: true });
        let userObj = {
            password: this.state.newPassword,
            username: this.state.username
        }
        if (this.state.newPassword !== "" && this.state.newPassword === this.state.reTypePassword) {
            axios.post(`auth/new-password`, userObj)
                .then(response => {
                    if (response.data.passwordUpdated === 200) {
                        this.setState({ loginStatus: 1, isLoading: false });
                        setTimeout(() => this.setState({ redirect: true }), 2000);
                    }
                }).catch(error => {
                    console.error('There was an error!', error);
                    this.setState({ loginStatus: 2, isLoading: false });
                });
        } else {
            this.setState({ loginStatus: 5, isLoading: false });
        }
    };

    renderAuthStatus = () => {
        const { loginStatus } = this.state;
        let message = '';
        let type = 'danger';

        switch (loginStatus) {
            case 1:
                message = 'Password changed successfully! Redirecting to login...';
                type = 'success';
                break;
            case 2:
                message = 'An error occurred. Please try again.';
                break;
            case 3:
                message = 'Incorrect verification code. Please try again.';
                break;
            case 4:
                message = 'Email address not found. Please check and try again.';
                break;
            case 5:
                message = 'Passwords do not match. Please try again.';
                break;
            default:
                return null;
        }

        return (
            <div className={`alert alert-${type}`} style={{ marginBottom: '20px', borderRadius: '8px' }}>
                {message}
            </div>
        );
    };

    renderPageContent = () => {
        const { page, isLoading } = this.state;

        switch (page) {
            case 1: // Verify Code Page
                return (
                    <>
                        <div className="alert alert-success" style={{ marginBottom: '20px', borderRadius: '8px' }}>
                            Check your email for the verification code
                        </div>
                        {this.renderAuthStatus()}
                        <form onSubmit={this.verifyCode}>
                            <div style={{ marginBottom: '25px' }}>
                                <label style={{ display: 'block', fontWeight: '500', marginBottom: '8px', color: '#374151', fontSize: '14px' }}>
                                    Verification Code
                                </label>
                                <input
                                    type="text"
                                    name="code"
                                    onKeyPress={this.onKeyUpCode}
                                    onChange={this.handleCodeInput}
                                    className="form-control"
                                    placeholder="Enter the 6-digit code"
                                    disabled={isLoading}
                                    style={{
                                        height: '50px',
                                        borderRadius: '12px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px',
                                        padding: '0 16px',
                                        textAlign: 'center',
                                        letterSpacing: '2px'
                                    }}
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={isLoading}
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    background: isLoading ? '#9ca3af' : 'linear-gradient(135deg, #0069d9 0%, #004ba2 100%)',
                                    border: 'none',
                                    borderRadius: '12px',
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px'
                                }}
                            >
                                {isLoading ? 'Verifying...' : 'Verify Code'}
                            </button>
                        </form>
                    </>
                );

            case 2: // New Password Page
                return (
                    <>
                        {this.renderAuthStatus()}
                        <form onSubmit={this.newPassword}>
                            <div style={{ marginBottom: '25px' }}>
                                <label style={{ display: 'block', fontWeight: '500', marginBottom: '8px', color: '#374151', fontSize: '14px' }}>
                                    New Password
                                </label>
                                <input
                                    type="password"
                                    name="newPassword"
                                    onKeyPress={this.onKeyUpPassword}
                                    onChange={this.handleNewPasswordInput}
                                    className="form-control"
                                    placeholder="Enter new password"
                                    disabled={isLoading}
                                    style={{
                                        height: '50px',
                                        borderRadius: '12px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px',
                                        padding: '0 16px'
                                    }}
                                />
                            </div>
                            <div style={{ marginBottom: '30px' }}>
                                <label style={{ display: 'block', fontWeight: '500', marginBottom: '8px', color: '#374151', fontSize: '14px' }}>
                                    Confirm New Password
                                </label>
                                <input
                                    type="password"
                                    name="reTypeOtherPassword"
                                    onKeyPress={this.onKeyUpReTypePassword}
                                    onChange={this.handleReTypePassword}
                                    className="form-control"
                                    placeholder="Confirm new password"
                                    disabled={isLoading}
                                    style={{
                                        height: '50px',
                                        borderRadius: '12px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px',
                                        padding: '0 16px'
                                    }}
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={isLoading}
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    background: isLoading ? '#9ca3af' : 'linear-gradient(135deg, #0069d9 0%, #004ba2 100%)',
                                    border: 'none',
                                    borderRadius: '12px',
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px'
                                }}
                            >
                                {isLoading ? 'Updating...' : 'Reset Password'}
                            </button>
                        </form>
                    </>
                );

            default: // Initial Forgot Password Page
                return (
                    <>
                        {this.renderAuthStatus()}
                        <form onSubmit={this.resetPassword}>
                            <div style={{ marginBottom: '30px' }}>
                                <label style={{ display: 'block', fontWeight: '500', marginBottom: '8px', color: '#374151', fontSize: '14px' }}>
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    onKeyPress={this.onKeyUp}
                                    onChange={this.handleUsernameInput}
                                    className="form-control"
                                    placeholder="Enter your email"
                                    disabled={isLoading}
                                    style={{
                                        height: '50px',
                                        borderRadius: '12px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px',
                                        padding: '0 16px'
                                    }}
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={isLoading}
                                style={{
                                    width: '100%',
                                    height: '50px',
                                    background: isLoading ? '#9ca3af' : 'linear-gradient(135deg, #0069d9 0%, #004ba2 100%)',
                                    border: 'none',
                                    borderRadius: '12px',
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    marginBottom: '25px'
                                }}
                            >
                                {isLoading ? 'Sending...' : 'Send Reset Code'}
                            </button>
                            <div style={{ textAlign: 'center' }}>
                                <a
                                    href="/login"
                                    style={{
                                        color: '#0069d9',
                                        textDecoration: 'none',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Back to Login
                                </a>
                            </div>
                        </form>
                    </>
                );
        }
    };

    render() {
        if (this.state.redirect === true && this.state.page === 2) {
            return <Navigate to="/login" />;
        }

        return (
            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #0069d9 0%, #004ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
            }}>
                <div style={{
                    background: 'white',
                    borderRadius: '20px',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
                    padding: '60px 50px',
                    width: '100%',
                    maxWidth: '450px',
                    textAlign: 'center'
                }}>
                    {/* Logo */}
                    <div style={{ marginBottom: '40px' }}>
                        <img
                            src={ApexLogo}
                            alt="APEX"
                            style={{
                                width: '120px',
                                height: 'auto',
                                marginBottom: '20px'
                            }}
                        />
                        <p style={{
                            color: '#6b7280',
                            fontSize: '16px',
                            margin: '0'
                        }}>
                            {this.state.page === 0 ? 'Enter your email to receive a reset code' :
                             this.state.page === 1 ? 'We\'ve sent a verification code to your email' :
                             'Enter your new password below'}
                        </p>
                    </div>

                    {/* Dynamic Content */}
                    <div style={{ textAlign: 'left' }}>
                        {this.renderPageContent()}
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;